// btw-front/src/components/auth/ProtectedRoute.jsx
//
// 역할 기반 라우트 가드. §8 매트릭스 구현.
//
// props
//  - allow: ['guest'|'pending'|'partner'|'admin', ...] — 허용 역할
//  - allowSignupToken: boolean — 신청 직후 임시 토큰(`/partners/pending` 전용)
//  - adminRedirect: 관리자가 일반 /partners/* 진입 시 /admin 흡수
//

import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { usePartnerSession } from "../../context/PartnerSessionContext";

export default function ProtectedRoute({
  allow = [],
  allowSignupToken = false,
  adminRedirect = false,
  children,
}) {
  const { role, signupToken, setLastIntent } = usePartnerSession();
  const location = useLocation();

  // 관리자 흡수 정책 우선 — 관리자는 일반 /partners/* 흐름 X
  if (role === "admin" && adminRedirect) {
    return <Navigate to="/admin" replace />;
  }

  // 토큰 진입 허용 (pending 페이지)
  if (allowSignupToken && signupToken) return children;

  // 허용 역할 매칭
  if (allow.includes(role)) return children;

  // 차단 — 역할별 리다이렉트
  if (role === "guest") {
    return (
      <RedirectWithIntent
        to="/partners"
        setLastIntent={setLastIntent}
        from={location.pathname + location.search}
      />
    );
  }
  if (role === "pending") return <Navigate to="/partners/pending" replace />;
  if (role === "partner") return <Navigate to="/partners/dashboard" replace />;
  if (role === "admin") return <Navigate to="/admin" replace />;
  return <Navigate to="/partners" replace />;
}

function RedirectWithIntent({ to, setLastIntent, from }) {
  useEffect(() => {
    if (from && from !== to) setLastIntent(from);
  }, [from, to, setLastIntent]);
  return <Navigate to={to} replace />;
}
